export const setCreateAccountDataReducer = (state, action) => {
  state.createAccountData = { ...state.createAccountData, ...action.payload };
};
